import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Card from '@components/Card/Card';
import urls from '@routes/urls';

const InquiriesCard: FC = () => {
  const { t } = useTranslation();

  return (
    <Card
      icon="/images/img-inquirystatus-circle.svg"
      title={t('dashboardCards.inquiries.title')}
      description={t('dashboardCards.inquiries.description')}
      link={{
        title: t('dashboardCards.inquiries.linkTitle'),
        routerLink: urls.inquiries,
      }}
    />
  );
};

export default InquiriesCard;
